class CharactersLimitCounter {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      this.tinymce = window.tinymce;

      this.selector = '.js-character-limit';
      this.warningThreshold = 0.9;
      this.elements = [];
      this.init();

      this.defaultLimits = {
        wysiwyg: 200,
        input: 50,
      }
    });
  }

  init() {
    const nodes = document.querySelectorAll(this.selector);

    if (!nodes.length) {
      return;
    }

    nodes.forEach(node => {
      const isWysiwyg = node.closest('.wp-editor-wrap') !== null;

      let max;

      if (isWysiwyg) {
        max = parseInt(node.closest('.wysiwyg-wrap').dataset.max, 10) || this.defaultLimits.wysiwyg;
      } else {
        max = parseInt(node.dataset.max, 10) || this.defaultLimits.input;
      }

      const counter = document.createElement('div');
      counter.className = 'character-counter';
      counter.style.marginTop = '4px';
      counter.style.fontSize = '0.875em';

      node.insertAdjacentElement('afterend', counter);

      const elementData = { node, counter, max, isWysiwyg };
      this.elements.push(elementData);

      if (isWysiwyg) {
        this.observeTinyMCE(node, elementData);
      } else {
        node.addEventListener('input', () => this.handleInput(elementData));
        this.updateCounter(elementData);
      }
    });
  }

  observeTinyMCE(textarea, elementData) {
    const fieldId = textarea.id;

    const setupEditor = () => {
      const editor = this.tinymce.get(fieldId);
      if (!editor) return;

      const max = elementData.max;

      // Update counter on input
      editor.on('input', () => {
        const text = editor.getContent({ format: 'text' }) || '';
        this.updateCounter({
          ...elementData,
          node: { value: text }
        });
      });

      // Prevent typing if over limit
      editor.on('keydown', (e) => {
        const text = editor.getContent({ format: 'text' }) || '';

        // Allow control keys (backspace, arrows, etc.)
        const ctrl = e.ctrlKey || e.metaKey;
        const ignoredKeys = [
          'Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
          'Delete', 'Tab', 'Escape', 'Enter'
        ];
        if (ignoredKeys.includes(e.key) || ctrl) return;

        if (text.length >= max) {
          e.preventDefault();
        }
      });

      // Prevent pasting over limit
      editor.on('paste', (e) => {
        e.preventDefault();

        const clipboardData = e.clipboardData || window.clipboardData;
        let pastedText = clipboardData.getData('text/plain') || '';

        // Get current plain text length
        const currentText = editor.getBody().innerText || '';
        const currentLength = currentText.length;
        const remaining = max - currentLength;

        if (remaining <= 0) {
          // Slice the pasted text to allowed length
          const slicedText = currentText.slice(0, remaining);
          pastedText = slicedText;

          // Remove current selection (TinyMCE allows you to overwrite selection cleanly)
          editor.selection.setContent('');

          // Insert sliced content
          editor.setContent(
            slicedText.replace(/\n/g, '<br>') // optional: preserve line breaks
          );
        };

        this.updateCounter({
          ...elementData,
          node: { value: pastedText }
        });
      });

      // Initial counter update
      const initialText = editor.getContent({ format: 'text' }) || '';
      this.updateCounter({
        ...elementData,
        node: { value: initialText }
      });
    };

    // Wait until TinyMCE is initialized
    const interval = setInterval(() => {
      if (this.tinymce.get(fieldId)) {
        clearInterval(interval);
        setupEditor();
      }
    }, 200);
  }

  handleInput(elementData) {
    const { node, max } = elementData;

    if (node.value.length > max) {
      node.value = node.value.slice(0, max);
    }

    this.updateCounter(elementData);
  }

  updateCounter({ node, counter, max }) {
    const length = node.value.length;
    const percent = length / max;

    counter.textContent = `${length}/${max} characters`;

    if (length >= max) {
      counter.style.color = 'red';
    } else if (percent >= this.warningThreshold) {
      counter.style.color = 'orange';
    } else {
      counter.style.color = 'green';
    }
  }
}


export default CharactersLimitCounter;
